import script from "./ActiveEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveEvents.vue?vue&type=script&setup=true&lang=js"

import "./ActiveEvents.vue?vue&type=style&index=0&id=68fe096a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68fe096a"]])

export default __exports__